var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41,
    height: 44,
    viewBox: "0 0 41 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_311",
    "data-name": "Rectangle 311",
    width: 41,
    height: 44,
    transform: "translate(-0.111 -0.202)",
    fill: "#202b53"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_471",
    "data-name": "Groupe 471",
    transform: "translate(0.111 0.202)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_471-2",
    "data-name": "Groupe 471",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_743",
    "data-name": "Trac\\xE9 743",
    d: "M1.292,18.087h15.5a1.292,1.292,0,0,0,1.292-1.292V1.292A1.292,1.292,0,0,0,16.794,0H1.292A1.292,1.292,0,0,0,0,1.292v15.5a1.292,1.292,0,0,0,1.292,1.292m1.292-15.5H15.5V15.5H2.584Z",
    transform: "translate(0.569 2.23)",
    fill: "#202b53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_744",
    "data-name": "Trac\\xE9 744",
    d: "M296.347,1.292A1.292,1.292,0,0,0,295.056,0h-15.5a1.292,1.292,0,0,0-1.292,1.292v15.5a1.292,1.292,0,0,0,1.292,1.292h15.5a1.292,1.292,0,0,0,1.292-1.292ZM293.764,15.5H280.845V2.584h12.919Z",
    transform: "translate(-256.16 2.23)",
    fill: "#202b53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_745",
    "data-name": "Trac\\xE9 745",
    d: "M0,295.056a1.292,1.292,0,0,0,1.292,1.292h15.5a1.292,1.292,0,0,0,1.292-1.292v-15.5a1.292,1.292,0,0,0-1.292-1.292H1.292A1.292,1.292,0,0,0,0,279.553Zm2.584-14.211H15.5v12.919H2.584Z",
    transform: "translate(0.569 -254.5)",
    fill: "#202b53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_746",
    "data-name": "Trac\\xE9 746",
    d: "M296.347,279.553a1.292,1.292,0,0,0-1.292-1.292h-15.5a1.292,1.292,0,0,0-1.292,1.292v15.5a1.292,1.292,0,0,0,1.292,1.292h15.5a1.292,1.292,0,0,0,1.292-1.292Zm-2.584,14.211H280.845V280.845h12.919Z",
    transform: "translate(-256.16 -254.5)",
    fill: "#202b53"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.4911f6ed5f1f63d6f0963dd4f2500424.svg";
export { ForwardRef as ReactComponent };